module.exports = __webpack_public_path__ + "img/qrcode_bg.b56c88a.png";